import { AccessPassEntity } from '@resident-select/domain/access-pass';
import { createEntityEvent } from '../../../shared/base';
import { createAction, props } from '@ngrx/store';
import { AccessEntity } from '@resident-select/domain/access';

export const CreatedAccessPassEvent = createEntityEvent<AccessPassEntity>('CreatedAccessPassEvent');

export const FilteredAccessPassesDomainEvent = createAction(
  'FilteredAccessPassesDomainEvent',
  props<{
    transactionId: string;
    data: {
      access: AccessEntity;
      accessPasses: AccessPassEntity[];
    }[];
  }>(),
);

export const UpdatedAccessPassDomainEvent = createAction(
  'UpdatedAccessPassDomainEvent',
  props<{
    accessPass: AccessPassEntity;
  }>(),
);
